import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import { Alert, AlertTitle, Button } from "@mui/material";
import { useRouter } from "next/router";
import { onSignOut } from "../../src/utils/queries";
import CircleSpinner from "../Spinner/Index";
import { useAuthProvider } from "../../context/AuthProvider";

const BlockedModal = ({ show, setShow, isCharityNotVerified }) => {
  const { mutate, data, isSuccess, isLoading } = onSignOut();
  const { user, clearState } = useAuthProvider();
  const router = useRouter();
  useEffect(() => {
    if (isSuccess) {
      sessionStorage.removeItem("token");
      router.replace("/login");
      clearState();
    }
  }, [isSuccess]);

  const handleOpen = () => {
    setShow(true);
  };


  const handleClose = () => {
    const path = router.pathname
    const isAdmin = path.includes('admin')
    if (isCharityNotVerified) {
        mutate()
    } else if(isAdmin) {
     router.push('/admin/overview')
    } else {
        router.push('/overview')
    }
    setShow(false);
  };

  return (
    <>
      <Dialog
        open={show}
        fullWidth
        maxWidth={"xs"}
        //   onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          // minHeight:'10rem',
          zIndex: "10010",
          "& .MuiDialog-paper": {
            px: "1.2em",
            py: "1em",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "grey.dark",
            justifyContent: "space-between",
            display: "flex",
            "& svg": {
              padding: "0",
            },
          }}
        >
          <Typography
            variant="h4"
            component={"h4"}
            fontWeight={500}
            lineHeight={"24px"}
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            {isCharityNotVerified
              ? "Charity verification failed"
              : " You are not authorized to view this page"}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Alert
            icon={
              <>
                <i
                  class="las la-times-circle la-md"
                  style={{ color: "#B20000" }}
                ></i>
              </>
            }
            severity={"error"}
            color={"error"}
            sx={{
              borderRadius: "8px",
              fontSize: "12px",
              marginBottom: "0.2em",
              background: "#FFF5F5",
              border: "1px solid #FFD1D1",
            }}
          >
            <AlertTitle sx={{ color: "#B30000", fontSize: "14px" }}>
              {isCharityNotVerified
                ? "Charity verification failed"
                : "Unauthorised access"}
            </AlertTitle>
            {isCharityNotVerified
              ? " Please contact support for more information, as you cannot proceed using the system until your account is verified as a charity"
              : " You do not possess the required permissions to access this service"}
          </Alert>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: "1.5em",
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "none",
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
              variant="contained"
              color="error"
              disableElevation
              disableFocusRipple
              disableRipple
            >
              {isLoading ? (
                <CircleSpinner />
              ) : isCharityNotVerified ? (
                "Logout"
              ) : (
                "Go back"
              )}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BlockedModal;
